module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/train-class-list/train-class-list.component.scss
// module id = 1540
// module chunks = 0